<template>
  <ClientOnly>
    <VueEasyLightbox
      :visible="store.showPreview"
      :imgs="imageUrls"
      :index="index"
      @hide="store.closePreview"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import { computed } from "vue";
// import { useWindowSize } from "@vueuse/core";
import { useArtworkActionStore } from "~/stores/artwork.actions";
// import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'
// const { width } = useWindowSize();
const store = useArtworkActionStore();

const imageUrls = computed<string[]>(() => store.previewUrls);
const index = computed<number>(() => store.previewIndex || 0);
</script>
